import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../services/api.service';
import {
  EffectiveAccountPlanDto,
  EntitlementEvaluationDto
} from '../models/entitlement.model';

@Injectable({ providedIn: 'root' })
export class AccountEntitlementsApiService {
  constructor(private readonly api: ApiService) {}

  getEffectivePlan(accountId: number): Observable<EffectiveAccountPlanDto> {
    return this.api.get<EffectiveAccountPlanDto>(`accounts/${accountId}/entitlements/effective-plan`);
  }

  /** Evalúa (dry-run) si la cuenta tiene habilitada una feature de plan. */
  evaluateFeature(accountId: number, featureCode: string): Observable<EntitlementEvaluationDto> {
    return this.api.post<EntitlementEvaluationDto>(
      `accounts/${accountId}/entitlements/evaluate`,
      { featureCode }
    );
  }
}
